/* eslint-disable no-mixed-spaces-and-tabs */
import React, {useState} from "react";
import PropTypes from "prop-types";
import Input from "../../Chat/shared/Input/Input";
import ItemChecked from "../../../assets/icons/passwordItem.svg";
import ItemUnchecked from "../../../assets/icons/PwItemUnchecked.svg";

const AccountModal = ({
                          dataUser,
                          setPhoneValue,
                          setAddressValue,
                          setCityValue,
                          setCPValue,
                          setEmailValue,
                          setPasswordValue,
                          newPasswordValue,
                          password,
                          showAccountModal,
                          setShowAccountModal,
                          setNewPasswordValue,
                          setVerifyPasswordValue,
                          verifiedPassword,
                          updateUserInfos,
                          scrollUpRef
                      }) => {
    // @TODO : Gérer la prise en compte des caractères requis pour le mot de passe (8 caractère, une majuscule, une minuscule, etc)
    // La logique est présente dans le code mais n'est pas appliquer, les icônes à cocher font déborder la modal de l'écran
    // Essayer peut être d'afficher une pop-up message d'erreur
    // onValidation = if (!strongPassword.trial(password) {setErrorMessage("Le pw doit contenir 8 caractères, etc.")}

    // Gère la logique de vérification des mot de passe
    const [majCheck, setMajCheck] = useState(false);
    const [minCheck, setMinCheck] = useState(false);
    const [numCheck, setNumCheck] = useState(false);
    const [characCheck, setCharacCheck] = useState(false);
    const [heightCheck, setHeightCheck] = useState(false);
    const [enableButton, setEnableButton] = useState(false);
    const [showItemPw, setShowItemPw] = useState(false);

    const handleResetPasswordCheck = () => {
        setNewPasswordValue("");
        setPasswordValue("");
        setVerifyPasswordValue("");
        setMinCheck(false);
        setMajCheck(false);
        setCharacCheck(false);
        setNumCheck(false);
        setNumCheck(false);
        setShowItemPw(false);
        setHeightCheck(false);
        setEnableButton(false);
        showAccountModal ? setShowAccountModal(false) : null;
    };

    const strongPasswordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^\-_#%€&*(),.?":{}|<>])[A-Za-z\d!@#$%^\-_#%€&*(),.?":{}|<>]{8,}$/;

    const handleNewPasswordValue = (e) => {
        const specialChar = /[!\-_#%$€@#$%^&*(),.?":{}|<>]/;
        const number = /\d/;
        const minus = /[a-z]/;
        const maj = /[A-Z]/;
        const passwordRegExp = /.{8,}/;

        // Test s'il existe un caractère spécial dans le mdp
        if (specialChar.test(e.target.value)) {
            setCharacCheck(true);
        } else {
            setCharacCheck(false);
        }
        // Test s'il existe un chiffre dans le mdp
        if (number.test(e.target.value)) {
            setNumCheck(true);
        } else {
            setNumCheck(false);
        }
        // Test s'il existe une miniscule dans le mdp
        if (minus.test(e.target.value)) {
            setMinCheck(true);
        } else {
            setMinCheck(false);
        }
        // Test s'il existe une majuscule dans le mdp
        if (maj.test(e.target.value)) {
            setMajCheck(true);
        } else {
            setMajCheck(false);
        }
        // Test si le mdp contient au minimum 8 caractères
        if (passwordRegExp.test(e.target.value)) {
            setHeightCheck(true);
        } else {
            setHeightCheck(false);
        }
        // Test si toutes les conditions sont réunis
        if (strongPasswordRegExp.test(e.target.value)) {
            setEnableButton(true);
        } else {
            setEnableButton(false);
        }
        setNewPasswordValue(e.target.value);
    };

    const handleUpdateInfos = () => {
        // Essayer peut être d'afficher une pop-up message d'erreur
        // if (!strongPassword.trial(password) {setErrorMessage("Le pw doit contenir 8 caractères, etc.")}
        // else {
        updateUserInfos();
        scrollUpRef.current.scrollIntoView();
        setCharacCheck(false);
        setMajCheck(false);
        setMinCheck(false);
        setHeightCheck(false);
        setNumCheck(false);
        // }
    };

    return (
        <>
            <div className="contentAccountModal">
                <p id="contentTitle">Vos informations</p>
                <div className="container-modal">
                    <form action="">
                        <div className="containerUserInfo">
                            <Input
                                email
                                valueToActive={dataUser.firstname}
                                label="Prénom"
                                value={dataUser.firstname}
                                disabled
                            />
                        </div>
                    </form>

                    <form action="">
                        <div className="containerUserInfo">
                            <Input
                                email
                                valueToActive={dataUser.name}
                                label="Nom"
                                value={dataUser.name}
                                disabled
                            />
                        </div>
                    </form>

                    <form action="">
                        <div className="containerUserInfo">
                            <Input
                                label="Téléphone"
                                valueToActive={dataUser.tel}
                                value={dataUser.tel}
                                onBlur={() => null}
                                onChange={(e) => setPhoneValue(e.target.value)}
                            />
                        </div>
                    </form>

                    <form action="">
                        <div className="containerUserInfo">
                            <Input
                                label="Adresse"
                                valueToActive={dataUser.adress}
                                value={dataUser.adress}
                                onBlur={() => null}
                                onChange={(e) => setAddressValue(e.target.value)}
                            />
                        </div>
                    </form>

                    <form action="">
                        <div className="containerUserInfo">
                            <Input
                                id={"ville"}
                                label="Ville"
                                valueToActive={dataUser.city}
                                value={dataUser.city}
                                onBlur={() => null}
                                onChange={(e) => setCityValue(e.target.value)}
                            />
                            <Input
                                id={"cp"}
                                label="Code postal"
                                valueToActive={dataUser.cp}
                                value={dataUser.cp == 0 ? "" : dataUser.cp}
                                onChange={(e) => setCPValue(e.target.value)}
                            />
                        </div>
                    </form>

                    <form action="">
                        <div className="containerUserInfo">
                            <Input
                                label="Email*"
                                valueToActive={dataUser.email}
                                value={dataUser.email}
                                onBlur={() => null}
                                onChange={(e) => setEmailValue(e.target.value)}
                            />
                        </div>
                    </form>
                    <form action="">
                        <div className="containerUserInfo">
                            <Input
                                type="password"
                                label="Mot de passe"
                                valueToActive={password}
                                value={password}
                                onBlur={() => null}
                                onChange={(e) => setPasswordValue(e.target.value)}
                            />
                        </div>
                        <div className="containerUserInfo">
                            <Input
                                type="password"
                                label="Nouveau mot de passe"
                                valueToActive={newPasswordValue}
                                value={newPasswordValue}
                                onChange={handleNewPasswordValue}
                                onFocus={() => setShowItemPw(true)}
                                onBlur={() => setShowItemPw(false)}
                            />
                        </div>
                        {showItemPw &&
                            <div className="passwordItem fade">
                                <div className="itemLine">
                                    {majCheck ? (<img alt="valide" src={ItemChecked}/>) : (
                                        <img alt="non valide" src={ItemUnchecked}/>)}
                                    <p>1 majuscule</p>
                                    {minCheck ? (<img alt="valide" src={ItemChecked}/>) : (
                                        <img alt="non valide" src={ItemUnchecked}/>)}
                                    <p>1 minuscule</p>
                                </div>
                                <div className="itemLine">
                                    {characCheck ? (<img alt="valide" src={ItemChecked}/>) : (
                                        <img alt="non valide" src={ItemUnchecked}/>)}
                                    <p>1 caractère spécial</p>
                                    {numCheck ? (<img alt="valide" src={ItemChecked}/>) : (
                                        <img alt="non valide" src={ItemUnchecked}/>)}
                                    <p>1 chiffre</p>
                                </div>
                                <div className="itemLine">
                                    {heightCheck ? (<img alt="valide" src={ItemChecked}/>) : (
                                        <img alt="non valide" src={ItemUnchecked}/>)}
                                    <p>8 caractères</p>
                                </div>
                            </div>
                        }
                        <div className="containerUserInfo">
                            <Input type="password" label="Confirmer nouveau mot de passe"
                                   valueToActive={verifiedPassword} value={verifiedPassword} onBlur={() => null}
                                   onChange={(e) => setVerifyPasswordValue(e.target.value)}/>
                        </div>
                    </form>
                    <div className="containerUserInfoAlert">
                        <p className="emailInfos">* Attention, si vous mettez à jour votre adresse email, vous serez
                            déconnecté. Vous devrez utiliser votre nouvelle adresse email/mot de passe pour vous
                            reconnecter.</p>
                    </div>

                    <div className="containerUserButton">
                        <button
                            className={"userButton"}
                            onClick={handleUpdateInfos}
                            disabled={showItemPw && !enableButton ? true : false}
                        >
                            Mettre à jour mes informations
                        </button>
                        <button className={"userButton"} onClick={handleResetPasswordCheck}> Annuler</button>
                    </div>
                </div>
            </div>
            <div className="modalBackground" onClick={handleResetPasswordCheck}></div>
        </>
    );
};

AccountModal.propTypes = {
    dataUser: PropTypes.object,
    setPhoneValue: PropTypes.func,
    setAddressValue: PropTypes.func,
    setCityValue: PropTypes.func,
    setCPValue: PropTypes.func,
    setEmailValue: PropTypes.func,
    setPasswordValue: PropTypes.func,
    newPasswordValue: PropTypes.string,
    password: PropTypes.string,
    showAccountModal: PropTypes.bool,
    setShowAccountModal: PropTypes.func,
    setNewPasswordValue: PropTypes.func,
    setVerifyPasswordValue: PropTypes.func,
    verifiedPassword: PropTypes.string,
    updateUserInfos: PropTypes.func,
    scrollUpRef: PropTypes.func,
};

export default AccountModal;
